import { render } from "./Orders.vue?vue&type=template&id=d6b38598&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=ts"
export * from "./Orders.vue?vue&type=script&lang=ts"

import "./Orders.vue?vue&type=style&index=0&id=d6b38598&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d6b38598"

export default script